<template>
  <div>
    <FilterDropDown
      v-for="(taxonomy, index) in restrictCategories(
        filtergroupids,
        0,
        3,
        tagGroups.taxonomy
      )"
      :key="taxonomy.id"
      :options="taxonomy.tags"
      :active="tags"
      :ref="taxonomy.id"
      :open="activeGroup[index]"
      :name="taxonomy.title"
      @inputChange="addFilter"
      @toggleFilters="toggleFilters(index, activeGroup[index])"
      class="filterDropDown"
    >
    </FilterDropDown>

    <DateFilterDropDown
      :options="tagGroups.created"
      :active="datetags"
      v-if="showYearFilter"
      :name="$t('PublishDate')"
      :open="showmore"
      @inputChange="addDateFilter"
      @toggleFilters="showYearFilters"
      class="filterDropDown"
    >
    </DateFilterDropDown>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { GenericSearchResponseFacets, TaxonomyTag, TaxonomyCategory, GenericSearchResponseFacetsCreatedItem } from "../client/src/models/index";

import FilterDropDown from "./FilterDropDown.vue";
import DateFilterDropDown from "./DateFilterDropDown.vue";

export default Vue.extend({
  name: "Filters",
  props: {
    tagGroups: {
      type: Object as () => GenericSearchResponseFacets,
      required: true,
      default: () => ({})

    },
    tags: {
      type: Array as () => TaxonomyTag[],
      required: true,
      default: () => ([])
    },
    datetags: {
      type: Array as () => GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => ([])
    },
    showYearFilter: {
      type: Boolean,
      required: true,
      default: false,
    },
    filtergroupids: {
      type: Array as () => string[],
      required: false,
      default: () => ([])
    },
  },
  watch: {
    tagGroups: function(val) {
      this.activeGroup = this.restrictCategories(
        this.filtergroupids,
        0,
        val.taxonomy.length - 1,
        val.taxonomy
      ).map((x) => false);
    },
  },
  data() {
    return {
      activeGroup: this.$props.filtergroupids.map((x) => false) as boolean[],
      showmore: false as boolean,
    };
  },
  components: {
    FilterDropDown,
    DateFilterDropDown,
  },
  computed: {
    tabIndexMore() {
      return this.showmore ? 0 : -1;
    },
  },
  methods: {
    restrictCategories(
      ids: string[],
      start: number,
      end: number,
      categories?: TaxonomyCategory[]
    ): TaxonomyCategory[] {
      if (categories) {
        if (ids !== undefined && ids.length < 1) {
          return categories.filter(function(
            cat: TaxonomyCategory,
            index: number
          ) {
            return index < end && index >= start;
          });
        }
        return categories.filter(function(
          cat: TaxonomyCategory,
          index: number
        ) {
          return (
            ids.includes(cat.id.toString()) && index < end && index >= start
          );
        });
      }
      return [];
    },
    showYearFilters() {
      this.$data.activeGroup = this.$props.filtergroupids.map((x) => false);
      if (this.$data.showmore) {
        this.$emit("toggleFilters", false);
      } else {
        this.$emit("toggleFilters", true);
      }
      this.$data.showmore = !this.$data.showmore;
    },
    toggleFilters(index: number, isOpen: boolean) {
      this.$data.showmore = false;
      this.$data.activeGroup = this.$props.filtergroupids.map((x) => false);
      if (!isOpen) {
        this.$set(this.$data.activeGroup, index, true);
        this.$emit("toggleFilters", true);
      } else {
        this.$emit("toggleFilters", false);
      }
    },
    addFilter(tag: TaxonomyTag) {
      if (this.tags.filter((x) => x.id === tag.id).length === 0) {
        this.tags.push(tag);
        this.$emit("change", this.tags);
      } else {
        for (let i = 0; i <= this.tags.length - 1; i++) {
          if (this.tags[i].id === tag.id) {
            this.tags.splice(i, 1);
          }
        }
        this.$emit("change", this.tags);
      }
    },
    addDateFilter(tag: GenericSearchResponseFacetsCreatedItem) {
      if (this.$props.datetags === undefined) return false;
      if (this.datetags.filter((x) => x.value === tag.value).length === 0) {
        this.datetags.push(tag);
        this.$emit("changeDate", this.datetags);
      } else {
        for (let i = this.datetags.length - 1; i >= 0; --i) {
          if (this.datetags[i].value === tag.value) {
            this.datetags.splice(i, 1);
          }
        }
        this.$emit("changeDate", this.datetags);
      }
    },
  },
});
</script>
